import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
// import CreateTemplate from './Create';
import TemplateListV1 from '../TemplateV1/Template/TemplateList.tsx';
import TemplateDetailsV1 from '../TemplateV1/Summary/TemplateDetails.tsx';
import TemplateUsersV1 from '../TemplateV1/Summary/TemplateUsersV1.tsx';
import { useResetRecoilState } from 'recoil';
import {
  channelListAtom,
  organisationFilterAtom,
  organisationResponseAtom,
} from '../../../Services/_states/index.js';
import CreateTemplates from '../TemplateV1/Template/Create.tsx';
import AppList from '../Manager/AppList.tsx';
import AppDetails from '../Manager/AppDetails/index.tsx';
import OptinUsers from '../TemplateV1/Template/OptinUser/OptinUsers.tsx';

const Whatsapp = () => {
  const resetOrganisationRes = useResetRecoilState(organisationResponseAtom);
  const resetOrganisationFilter = useResetRecoilState(organisationFilterAtom);
  const resetChannelList = useResetRecoilState(channelListAtom);
  const location = useLocation();

  useEffect(() => {
    const targetRoutes = ['/r/whatsapp/template-list', '/r/whatsapp/template-details/'];
    if (targetRoutes.some((route) => location.pathname.startsWith(route))) {
      resetOrganisationFilter();
      resetOrganisationRes();
      resetChannelList();
    }
  }, [location]);

  return (
    <>
      <Routes>
        {/* <Route exact path={`/create-template`} element={<CreateTemplate />} /> */}
        {/* <Route exact path={`/edit-template/:templateName/:botNumber`} element={<CreateTemplate />} /> */}
        <Route
          exact
          path={'/template-users/:templateName/:templateId/:templateSentDate'}
          element={<TemplateUsersV1 />}
        />
        <Route
          exact
          path={'/template-details/:templateName/:botNumber'}
          element={<TemplateDetailsV1 />}
        />
        <Route exact path={'/template-list'} element={<TemplateListV1 />} />
        <Route exact path={'/create-template'} element={<CreateTemplates />} />
        <Route
          exact
          path={`/edit-template/:templateName/:botNumber`}
          element={<CreateTemplates />}
        />
        <Route path={'/manager/app-list'} element={<AppList />} />
        <Route path={'/manager/app-details'} element={<AppDetails />} />
        <Route path={'/optin-users'} element={<OptinUsers />} />
      </Routes>
    </>
  );
};
export default Whatsapp;
